import * as React from 'react';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Inner from './Inner/Inner';
import { LibraryCard, CardProperties } from '../../types/LibraryCard';
import { useMediaQuery } from 'react-responsive';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from "@material-ui/icons/Close";

interface Props {
	bookExternalId?: string;
	bookWooId?: number;
	onClose: () => void;
	onSaved?: () => void;
	saveCard?: (card: LibraryCard) => Promise<number>;
	saveProperties?: (cardId: number, properties: CardProperties) => Promise<boolean>;
}

const BookDialogPreview: React.FunctionComponent<Props> = props => {
	const isMobile = useMediaQuery({maxWidth: '600px'});

	return (
		<Dialog
			open={!!props.bookExternalId}
			onClose={props.onClose}
			fullScreen={isMobile}
			scroll="body"
			classes={{
				paper: "book-calendar-dialogCard__paper"
			}}
		>
			{isMobile && (
				<div className="book-calendar-dialogCard-toolbar">
					<IconButton onClick={props.onClose}>
						<CloseIcon />
					</IconButton>

					<div className="book-calendar-dialogCard-toolbar__header">
						Добавить в библиотеку
					</div>
				</div>
			)}

			<Inner
				bookExternalId={props.bookExternalId}
				bookWooId={props.bookWooId}
				onSaved={props.onSaved}
				saveCard={props.saveCard}
				saveProperties={props.saveProperties}
				onClose={props.onClose}
			/>
		</Dialog>
	);
};

export default BookDialogPreview;
